const CONSENT_STORAGE_KEY = 'wreadia_consent';
const CONSENT_DURATION_MONTHS = 6;

export const useConsent = () => {
  const isVisible = useState('consent_banner_visible', () => false);

  const show = () => {
    isVisible.value = true;
  };

  const hide = () => {
    isVisible.value = false;
  };

  const saveConsent = (choice: 'granted' | 'denied') => {
    const consentData = {
      choice,
      timestamp: Date.now(),
    };
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consentData));
  };

  const getConsent = () => {
    const stored = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!stored) return null;

    try {
      const { choice, timestamp } = JSON.parse(stored);

      // Vérifier l'expiration (6 mois)
      const expirationDate = new Date(timestamp);
      expirationDate.setMonth(expirationDate.getMonth() + CONSENT_DURATION_MONTHS);

      if (Date.now() > expirationDate.getTime()) {
        localStorage.removeItem(CONSENT_STORAGE_KEY);
        return null;
      }

      return choice as 'granted' | 'denied';
    } catch (e) {
      localStorage.removeItem(CONSENT_STORAGE_KEY);
      return null;
    }
  };

  return {
    isVisible,
    show,
    hide,
    saveConsent,
    getConsent,
  };
};
